/**
 * Compare tray (localStorage, max 4 products).
 */
(function () {
  const KEY = 'pi_compare_v1';
  const MAX = 4;

  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '[]');
    } catch {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (_) {}
  }

  function drawer() {
    return document.querySelector('[data-pi-compare-drawer]');
  }

  function render() {
    const el = drawer();
    if (!el) return;
    const list = read();
    const listEl = el.querySelector('[data-pi-compare-list]');
    const emptyEl = el.querySelector('[data-pi-compare-empty]');
    if (!listEl) return;
    listEl.innerHTML = list
      .map(
        (item) => `
      <a href="${item.url}" class="pi-compare__item">
        <strong>${item.title}</strong>
        <span>${item.price || ''}</span>
      </a>`,
      )
      .join('');
    if (emptyEl) emptyEl.hidden = list.length > 0;
    listEl.hidden = list.length === 0;
  }

  function open() {
    const el = drawer();
    if (!el) return;
    render();
    el.hidden = false;
  }

  function close() {
    const el = drawer();
    if (el) el.hidden = true;
  }

  function toggle(btn) {
    const id = btn.dataset.productId;
    if (!id) return;
    let list = read();
    const idx = list.findIndex((item) => String(item.id) === String(id));
    if (idx >= 0) {
      list.splice(idx, 1);
      btn.classList.remove('is-active');
    } else {
      if (list.length >= MAX) list.shift();
      list.push({
        id,
        title: btn.dataset.productTitle || 'Product',
        url: btn.dataset.productUrl || '#',
        price: btn.dataset.productPrice || '',
      });
      btn.classList.add('is-active');
    }
    write(list);
    render();
    open();
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-pi-compare-close]')) {
      e.preventDefault();
      close();
      return;
    }
    if (e.target.closest('[data-pi-compare-clear]')) {
      e.preventDefault();
      write([]);
      document.querySelectorAll('[data-pi-compare-toggle].is-active').forEach((b) => b.classList.remove('is-active'));
      render();
      return;
    }
    const btn = e.target.closest('[data-pi-compare-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn);
  });

  document.querySelectorAll('[data-pi-compare-toggle]').forEach((btn) => {
    if (read().some((item) => String(item.id) === String(btn.dataset.productId))) {
      btn.classList.add('is-active');
    }
  });
})();
